<template>
    <div class="bax-order-list bax-order-list-icon  bax-order-multi-list-icon">
        <ul>
            <li v-for="(order, i) in orders" :key="i">
                <a href="#" @click.prevent="gotoManageSingleOrder(order)" class="d-md-flex flex-wrap">
                    <div class="bax-order-detail">
                       Order Reference Number:
                        <div class="d-flex align-items-center">
                            <h4>{{ order.orderRefView?order.orderRefView:order.orderReference }}</h4>
                            <span class="ml-2"><i class="icon-chevron-right"></i></span>
                        </div>
                        <ul>
                            <li>Order Date: <strong>{{ typeof order.orderDate !== 'undefined' ? order.orderDate : '--' }}</strong></li>
                            <li>Items: <strong>{{ order.items > 0 ? order.items : '(loading)'}}</strong></li>
                        </ul>
                        <bax-order-audit-detail :order="order" />
                    </div>
                    <div class="bax-order-icon ml-auto">
                        <ul>
                            <li class="d-flex">
                                <span class="d-flex justify-content-center align-items-center"><i class="icon-pending"></i></span>Pending <strong>{{order.Pending }}</strong>
                            </li>
                            <li class="d-flex">
                                <span class="d-flex justify-content-center align-items-center"><i class="icon-download"></i></span>Reviewed <strong>{{order.Reviewed }}</strong>
                            </li>
                            <li class="d-flex">
                                <span class="d-flex justify-content-center align-items-center"><i class="icon-manufactured"></i></span>In Manufacture <strong>{{ order.Manufactured }}</strong>
                            </li>
                            <li class="d-flex">
                                <span class="d-flex justify-content-center align-items-center"><i class="icon-dispatched"></i></span>Shipped <strong>{{ order.Dispatched }}</strong>
                            </li>
                            <li class="d-flex" v-if="!isTPN()">
                                <span class="d-flex justify-content-center align-items-center"><i class="icon-onhold"></i></span>On Hold <strong>{{ order.onHold }}</strong>
                            </li>
                            <li class="d-flex">
                                <span class="d-flex justify-content-center align-items-center"><i class="icon-cancel"></i></span>Cancelled <strong>{{ order.Cancelled }}</strong>
                            </li>
                        </ul>

                    </div>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import BaxOrderAuditDetail from '@/views/Order/BaxOrderAuditDetail.vue';
    import tpnMixin from '@/mixins/tpnMixin';

    export default {
        name: 'BaxOrderList',
        mixins: [tpnMixin],
        props: {
            orders: {
                required: true,
            },
        },
        components: {
            BaxOrderAuditDetail,
        },
        methods: {
            gotoManageSingleOrder(order) {
                if (order.type !== 'draft') {
                  const orderPage = (this.isTPN() ? 'manageSingleOrderTPN' : 'manageSingleOrder');
                    this.$router.push({
                        name: orderPage,
                        params: {
                            orderId: order.groupOrderID,
                        },
                        query: {
                            from: this.$route.name,
                            order: this.$route.query.order,
                            search: this.searchKeyword,
                        },
                    });
                } else {
                    const orderPage = (this.isTPN() ? 'reviewCompleteTPN' : 'reviewComplete');
                    this.$router.push({
                        name: orderPage,
                        params: {
                            orderId: order.orderReference,
                        },
                    });
                }
            },
        },
    };
</script>
